/**
 * region for libraries*/
import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'


export class RelationshipsAddedVsDeletedChart extends Component {
    static displayName = RelationshipsAddedVsDeletedChart.name;

    constructor(props) {
        super(props);

        this.state = {
            addedTotal: 0,
            deletedTotal: 0,
            mode: Constants.MODE_LOADING,
            filters: { ...this.props.filters },         
            options: {
                chart: {
                    stacked: true,            
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                }, 
                grid: {
                    show: false,
                },
                tooltip: {
                    shared: true,                   
                },
                responsive: [{
                    breakpoint: 1500,
                    options: {
                        chart: {
                            width: 300,
                            height: 200
                        },                      
                    }
                }],
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '90%',
                    },
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    categories: [],
                    axisTicks: {
                        show: false
                    },
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                },
                legend: {
                    show: false,
                    fontWeight: 100
                },
                fill: {
                    opacity: 1
                },
                title: {
                    text: 'Relationships',
                    align: 'left',
                    style: {
                        fontSize: "20px",
                        fontWeight: 100,
                        color: '#666'
                    }
                },
                subtitle: {
                    text: 'Added vs Deleted',
                    align: 'left',
                    style: {
                        fontWeight: 100
                    }
                },
            },
            series: [{  name: '',
                        data: []
                    },
                    {   name: '',
                        data: []
                    }],
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!typing.areEqual(this.state.filters, nextProps.filters)) {
            this.setState({
                mode: Constants.MODE_LOADING,
                filters: { ...nextProps.filters }
            }, function () { this.load(); });
        }
    }

    load() {

        const self = this;

        let requestData = {
            ...this.state.filters,
        };

        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_CHART_RELATIONSHIPS_ADDED_VS_DELETED,
            {
                requestData: requestData,
                success: function (response) {
                    let optionsCopy = Object.assign({}, self.state.options);
                    let seriesCopyAdded = [...self.state.series];
                    let seriesCopyDeleted = [...self.state.series];
                    let seriesUpdatedAdded = response.data.map(serie => typing.numberWithCommas(serie.ADDED));
                    let seriesUpdatedDeleted = response.data.map(serie => typing.numberWithCommas(serie.DELETED));
                    let labelsUpdated = response.data.map(label => typing.convertToDateShortMonth(label.LOGDATE));
                    let seriesAddedTotal =  response.data.reduce((result,element)=> { return result + element.ADDED }, 0);
                    let seriesDeletedTotal =  response.data.reduce((result,element)=> { return result + element.DELETED }, 0);

                    optionsCopy.xaxis.categories = labelsUpdated;
                    seriesCopyAdded[0].data = seriesUpdatedAdded;
                    seriesCopyDeleted[0].data = seriesUpdatedDeleted;

                    self.setState({
                        addedTotal: seriesAddedTotal,
                        deletedTotal: seriesDeletedTotal,
                        mode: Constants.MODE_LOADED,
                        options: optionsCopy,
                        series: [{  name: 'added',
                                    data: seriesUpdatedAdded
                                },
                                {   name: 'deleted',
                                    data: seriesUpdatedDeleted
                                }]
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <div className="chart-container-activity">
                <div className="total-values-chart-activity">
                    Added Total {this.state.addedTotal}<br />
                    Deleted Total {this.state.deletedTotal}
                </div>
                <div className="col-4 col-md-6">
                <div id="chart">
                    <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="200" width="400" />
                </div>
                </div>
            </div>
        )
    }
}



    

   
